import { useState, useMemo, useCallback } from 'react';

const useFormFields = (initialFields, validators, onSubmit) => {
  const [fields, setFields] = useState(initialFields);
  const [errors, setErrors] = useState({});

  const hasErrors = useMemo(() => Object.values(errors).some(val => val), [
    errors
  ]);

  const onChange = useCallback(
    (event, checked) => {
      const { name, value } = event.target;
      const newValue = checked !== undefined ? checked : value;
      const newFields = {
        ...fields,
        [name]: newValue
      };

      setFields(newFields);
      // confirm password needs to be validated alongside new password
      if (name === 'confirmPassword') {
        setErrors(validators.all(newFields) || {});
      } else {
        setErrors({ ...errors, [name]: validators.single(name, newValue) });
      }
    },
    [fields, validators, errors]
  );

  const onSubmitForm = useCallback(
    event => {
      event.preventDefault();

      const newErrors = validators.all(fields);
      setErrors(newErrors || {});
      if (!newErrors) onSubmit(fields);
    },
    [fields, validators, onSubmit]
  );

  return [fields, errors, hasErrors, onChange, onSubmitForm];
};

export default useFormFields;
